<template>
  <div class="file-input">
    <div class="el-input__inner" v-popover:filepreview>
      <i class="el-icon-refresh uploading" v-if="uploading"></i>
      <i class="el-icon-circle-check uploaded" v-if="uploaded"></i>
      <span class="status text-info" v-show="!text">{{ label }}</span>
      <span class="status">{{ text }}</span>
      <div class="progress" :style="{width: this.progress + '%'}" v-if="uploading"></div>
    </div>
    <el-button-group :class="tiny ? 'btn-group-tiny btn-shortcut-buttons' : 'btn-shortcut-buttons'">
      <!-- <el-button v-if="showButton('delete')" title="移除文件" icon="el-icon-delete" @click="handleRemove"></el-button>
      <el-button v-if="showButton('download')" title="下载文件" icon="el-icon-download" :disabled="!filePath || downloading" @click="handleDownloadClick"></el-button> -->
      <el-button v-if="showSearch" title="从文件库中搜索文件" icon="el-icon-search" v-popover:filemanager></el-button>
      <el-button v-if="showTtsAudio" title="使用TTS生成音频" icon="el-icon-microphone" v-popover:tts></el-button>
      <!-- <el-button v-if="showButton('select')" title="选择文件上传" icon="el-icon-more" @click="handleSelectClick"></el-button> -->
    </el-button-group>
    <el-dropdown split-button @click="handleSelectClick" @command="handleCommand"
                 :class="tiny ? 'btn-group-tiny btn-shortcut-buttons' : ''">
      <i class="el-icon-more"></i>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-delete" command="handleRemove">移除文件</el-dropdown-item>
        <el-dropdown-item icon="el-icon-download" command="handleDownloadClick" :disabled="!filePath || downloading">
          下载文件
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <input type="file" :multiple="multiple" :accept="accept" ref="file" @change="handleSelectFile">
    <el-popover
        ref="filepreview"
        placement="bottom-start"
        width="500"
        trigger="click">
      <FilePreview :src="value"></FilePreview>
    </el-popover>
    <el-popover
        ref="filemanager"
        v-if="showSearch"
        placement="bottom-end"
        width="600"
        trigger="click">
      <FileSelect :accept="accept" :prepage="15" @input="handleSelectInput"></FileSelect>
    </el-popover>
    <el-popover
        ref="tts"
        placement="top-end"
        width="800"
        v-if="showTtsAudio"
        @show="handleTtsShow"
        trigger="click">
      <SSMLEditor ref="ttsEditor" :value="value" @input="handleTtsInput"></SSMLEditor>
    </el-popover>
  </div>
</template>

<script>
import utils from './../js/utils'
import FilePreview from './filemanager/FilePreview'
import FileSelect from './filemanager/FileSelect'
import SSMLEditor from './tts/SSMLEditor.vue'
import {getFileClient} from "@/js/file.js";
import {toFileSize} from "@/js/formatter.js";

export default {
  name: 'FileInput',
  props: {
    accept: String,
    label: String,
    value: [String, Array],
    multiple: Boolean,
    tiny: Boolean,
    hideTools: String
  },
  components: {FilePreview, FileSelect, SSMLEditor},
  data() {
    return {
      text: '',
      filePath: '',
      bucket: null,
      uploading: false,
      uploaded: false,
      downloading: false,
      progress: 0,
      nativeValue: null,
      rules: {
        default: {base: '@oss/upload', dest: '/sc/upload', bucket: 'hskonline'},
        audio: {base: '@audio', dest: '/sc/audio', bucket: 'superchinese'},
        video: {base: '@video', dest: '/sc/video', bucket: 'superchinese'},
      },
    }
  },
  computed: {
    showTtsAudio() {
      return !this.accept || /audio/.test(this.accept)
    },
    showSearch() {
      return this.accept && this.showButton('search');
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal !== null && newVal !== undefined && newVal === this.nativeValue) {
          return
        }
        this.initText()
      },
      immediate: true
    }
  },
  methods: {
    getOss(bucket) {
      return getFileClient(bucket || this.bucket || this.rules.default.bucket);
    },
    initText() {
      this.uploading = false
      this.uploaded = false
      this.$nextTick(() => {
        this.$refs.file.value = ''
      })
      if (this.value) {
        let path = typeof this.value === 'string' ? this.value : this.value[0]
        this.text = path.substring(path.lastIndexOf('/') + 1)
        let rule = this.getRuleByPath(path)
        path = utils.relativeUrl(path, '@base')
        this.filePath = path
        this.bucket = rule ? rule.bucket : null
        this.getOss().filename(path).then(filename => {
          if (filename) {
            this.text = filename;
          }
        })
      } else {
        this.text = ''
      }
    },
    getRuleByPath(path) {
      return Object.values(this.rules).find(r => path.startsWith(r.base));
    },
    showButton(name) {
      return !this.hideTools || this.hideTools.indexOf(name) < 0
    },
    handleCommand(command) {
      if (command in this) this[command]()
    },
    handleDownloadClick() {
      this.downloading = true
      this.getOss().download(this.filePath, this.text).then(res => {
        this.downloading = false
      }).catch(error => {
        this.downloading = false
        console.log(error)
      })
    },
    handleSelectClick() {
      this.$refs.file.click()
    },
    handleSelectInput(url) {
      this.$refs.file.value = ''
      this.$emit('input', url)
      this.$refs.filemanager.doClose()
    },
    handleTtsInput(url) {
      this.$refs.file.value = ''
      this.$emit('input', url)
      this.$refs.tts.doClose()
    },
    handleTtsShow() {
      this.$refs.ttsEditor.initTts()
    },
    handleRemove() {
      this.$refs.file.value = ''
      this.nativeValue = ''
      this.text = ''
      this.filePath = ''
      this.$emit('input', this.nativeValue)
    },
    handleSelectFile(event) {
      if (this.$refs.file.files.length === 0) {
        return
      }
      this.beforeUpload(this.$refs.file.files[0])
      let results = []
      for (let file of this.$refs.file.files) {
        results.push(this.upload(file, (p) => {
          this.progress = p * 100
        }))
      }
      Promise.all(results).then(res => {
        let urls = res.map(f => f.url)
        this.nativeValue = this.multiple ? urls : urls[0]
        this.$emit('input', this.nativeValue)
        this.afterUpload(this.$refs.file.files[0])
      })
    },
    beforeUpload(file) {
      this.uploading = true
      this.uploaded = false
      this.text = '正在上传中...（' + toFileSize(file.size) + '）'
    },
    afterUpload(file) {
      this.uploading = false
      this.uploaded = true
      this.text = file.name + '（' + toFileSize(file.size) + '）'
    },
    getDest(file) {
      if (/^video\//.test(file.type)) {
        return this.rules.video
      }
      if (/^audio\//.test(file.type)) {
        return this.rules.audio
      }
      return this.rules.default
    },
    upload(file, progress) {
      let dest = this.getDest(file);
      return this.getOss(dest.bucket).upload(file, {...dest, progress});
    }
  }
}
</script>

<style lang="scss" scoped>
input[type="file"] {
  display: none;
}

.file-input {
  display: flex;

  .el-input__inner {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    position: relative;
    overflow: hidden;

    > span {
      position: relative;
      z-index: 1;
    }
  }

  .progress {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 1px;
    background-color: #409eff;
  }

  .el-button:first-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.el-button-group {
  display: flex;

  + .el-dropdown {
    white-space: nowrap;
  }

  + .el-dropdown::v-deep > .el-button-group > .el-button:first-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &.btn-group-tiny > .el-button {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.btn-shortcut-buttons .el-button:last-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
}

.el-dropdown.btn-group-tiny::v-deep .el-button:first-child {
  padding-left: 15px;
  padding-right: 15px;
}

.uploading {
  position: relative;
  left: -7px;
  margin-right: -7px;
  animation: rotating .7s linear infinite;
}

.uploaded {
  color: #67C23A;
  position: relative;
  left: -7px;
  margin-right: -7px;
}
</style>
